module.exports = __webpack_public_path__ + "img/carshinaused_28.7cdaad35.jpg";